import { graphqlClientFactory } from '@sceneio/graphql-queries/src'

export const graphqlClient = graphqlClientFactory({
  url: import.meta.env.VITE_BACKEND_URL,
})
